var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-section"},[_c('div',{staticClass:"filter-section__head",attrs:{"aria-label":(_vm.title + " details")}},[_c('div',{staticClass:"heading"},[_vm._v(_vm._s(_vm.title))])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }